'use strict';

import { getLoginRequiredResolveObj } from '../shared/utils/angularUtils';
import { NAVIGATION_ICON } from '../shared/constants/system/navigationIcons';

export const releasesModule = angular
  .module('app.releases', [])
  .config(releasesConfig);

releasesConfig.$inject = ['$routeProvider'];

function releasesConfig($routeProvider) {
  $routeProvider
    .when('/releases', {
      template: '<ngz-releases></ngz-releases>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: null,
        breadcrumbs: [
          { label: 'Releases', icon: NAVIGATION_ICON.NEW_RELEASES }
        ]
      }
    });
}
